import { createFileRoute } from "@tanstack/react-router";
import EmailCaptureForm from "@/components/common/emailCaptureForm";
import BreadcrumbJsonLd from "@/components/common/breadcrumbJsonLd";

const BASE_URL = "https://datafirstjobs.com";
const SITE_URL = `${BASE_URL}/newsletter`;

export const Route = createFileRoute("/newsletter")({
  head: () => ({
    meta: [
      {
        title: "Newsletter | Data First Jobs",
      },
      {
        name: "description",
        content:
          "Carefully selected data engineering and analytics jobs delivered to your inbox twice a week. Filtered by stack, role, and seniority.",
      },
      {
        property: "og:title",
        content: "Newsletter | Data First Jobs",
      },
      {
        property: "og:description",
        content:
          "Carefully selected data engineering and analytics jobs delivered to your inbox twice a week.",
      },
      { property: "og:url", content: SITE_URL },
    ],
    links: [{ rel: "canonical", href: SITE_URL }],
  }),
  component: NewsletterPage,
});

function NewsletterPage() {
  return (
    <>
      <BreadcrumbJsonLd
        items={[{ name: "Home", url: BASE_URL }, { name: "Newsletter" }]}
      />
      <div className="mx-auto max-w-xl px-4 py-16 sm:py-24">
        <h1 className="text-polaris-navy mx-auto mb-4 max-w-[24ch] text-center text-3xl font-semibold tracking-tight text-balance sm:text-4xl">
          Data jobs that actually match your stack
        </h1>
        <p className="mx-auto mb-10 max-w-[44ch] text-center text-lg text-pretty text-gray-600">
          I dig through hundreds of listings so you don't have to. Twice a week,
          straight to your inbox.
        </p>

        <ul className="mx-auto mb-10 w-fit space-y-3 text-gray-700">
          <li className="flex items-start gap-3">
            <span className="text-polaris-orange mt-0.5">&#10003;</span>
            <span>
              Carefully selected roles filtered by tech stack, seniority, and
              location
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-polaris-orange mt-0.5">&#10003;</span>
            <span>Delivered twice a week, Tuesday and Friday</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="text-polaris-orange mt-0.5">&#10003;</span>
            <span>100% free. No spam. Unsubscribe in one click.</span>
          </li>
        </ul>

        <EmailCaptureForm buttonText="Get Jobs Twice a Week" />
      </div>
    </>
  );
}
